/**
 * Извлекает тип из URL Flixsnip
 * @param url - URL вида https://flixsnip.com/movie/47
 * @returns тип (например, 'movie') или null
 */
export function extractFlixsnipType(url: string): string | null {
  if (!url) {
    return null;
  }

  const parts = url.split('/').filter(part => part.length > 0);

  if (parts.length < 2) {
    return null;
  }

  // Ищем последний числовой элемент (ID) и возвращаем элемент перед ним (тип)
  for (let i = parts.length - 1; i >= 0; i--) {
    if (!isNaN(Number(parts[i]))) {
      // Найден числовой ID, возвращаем элемент перед ним
      return i > 0 ? parts[i - 1] : null;
    }
  }

  // Если числовой ID не найден, возвращаем предпоследний элемент
  return parts.length >= 2 ? parts[parts.length - 2] : null;
}
